import axios from "axios";
import { RESPONSE_STATUS_UNAUTHORIZED } from "../utils/Constant";
import { refreshToken } from "./refreshToken";
import { getAuth, getIsGuest, updateAuth } from "../utils/localStoreHelper";
import { URL_AUTH } from "../utils/Constant";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const setupInterceptors = (store) => {
  axios.interceptors.request.use(
    (config) => {
    const auth = getAuth();
    if (!auth) {
        store.dispatch({
          type: "SET_AUTH_MODAL",
          data: {
            modal: true
          },
        });
      }
      const isGuest = getIsGuest();
      if (!isGuest) {
        config.headers.Authorization = `Bearer ${getAuth().token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (res) => res,
    async (error) => {
      const status = error.response ? error.response.status : null;
      if (status === RESPONSE_STATUS_UNAUTHORIZED) {
        const isGuest = getIsGuest();
        if (!isGuest) {
          // если пользователь авторизован
          const data = await refreshToken();
          if (!(data instanceof Error)) {
            if (data.success) {
              const authKey = {
                token: data.token,
                isGuest: false,
              };
              updateAuth(authKey);
              localStorage.removeItem("token_requested");
              headers.Authorization = `Bearer ${data.token}`;

              const originalRequestConfig = error.config;
              if (originalRequestConfig) {
                delete originalRequestConfig.headers.Authorization;
                originalRequestConfig.headers.Authorization = `Bearer ${data.token}`; // use from defaults

                return await axios.request(originalRequestConfig);
              }
            } else {
              /* data.success = false - если refresh-token невалидный. нужно вывести модальное окно и оповестить об этом пользователя.
                  если пользователь выберет залогинится то перенаправить на URL_AUTH,
                  если выберет остаться незалогиненым то выполнить код ниже.
              */             
              // Показываем модальное окно
              store.dispatch({
                type: "SET_AUTH_MODAL",
                data: {
                  modal: true
                },
              });
            }
          } else {
            // если ответ на запрос токена пришел с ошибкой
            if (!localStorage.getItem("token_requested")) {
              // проверяем есть ли ключ, если мы еще не запрашивали токен, то ставим ключ и перенаправляем на авторизацию
              // если ключ уже есть, никуда не перенаправляем
              localStorage.setItem("token_requested", "true");
              const auth = getAuth();
              window.location.href = auth.url ? auth.url : URL_AUTH;
            }
          }
        }
      } else if (error.response?.data.message === "No refresh token found.") {
        if (!localStorage.getItem("token_requested")) {
          // проверяем есть ли ключ, если мы еще не запрашивали токен, то ставим ключ и перенаправляем на авторизацию
          // если ключ уже есть, никуда не перенаправляем
          localStorage.setItem("token_requested", "true");
          const auth = getAuth();
          window.location.href = auth.url ? auth.url : URL_AUTH;
        }
      }

      throw error;
    }
  );
};
